import cn from '../../../common/className.js'
import EnableLabelProperty, {PickLabelProperty} from './EnableLabelProperty.js'
import {useLabelConfigContext} from '../LabelConfigContext.js'
import useLabelProperty from './useLabelProperty.js'
import {useSelector} from '../../../store.js'
import {isLabelPropertyEnabledSelector} from '../../../data/labelInfos/index.js'

/**
 * Common button component for label info config
 *
 * @param {Object} props
 * @param {String} [props.className]
 * @param {String} [props.id]
 * @param {Boolean} [props.disabled]
 * @param {Boolean} [props.hide]
 * @param {String} [props.label]
 * @param {Function} [props.Label]
 * @param {Function} props.onClick
 * @param {(String|Boolean)} [props.labelProperty]
 * @param {Function} [props.labelPropertyCheckedSelector]
 * @param {Object} [props.propertySpecs]
 * @param {Function} props.propertySpecs.labelPropertiesFunc
 * @param {Array} props.propertySpecs.validShipperTypes
 * @param {Function} props.propertySpecs.dependentPropertiesFunc
 * @param {Function} props.propertySpecs.validLabelPropertiesFunc
 * @param {String} [props.errorMessage]
 * @param {Node} [props.children]
 * @returns {React.ReactNode}
 */
export default function ConfigButton({
  className,
  id,
  disabled,
  hide,
  label,
  Label,
  onClick,
  labelProperty,
  labelPropertyCheckedSelector,
  propertySpecs,
  errorMessage,
  children,
}) {
  const {labelInfoID, shipperType, isLabelEnableMode, isSummary, isPickMode} =
    useLabelConfigContext()

  labelProperty = labelProperty || ''
  id = id || `${labelInfoID}__${labelProperty}`

  useLabelProperty({
    labelProperty,
    propertySpecs,
  })

  const isLabelPropertyEnabled = useSelector((state) =>
    isLabelPropertyEnabledSelector(state, {
      labelInfoID,
      labelProperty,
    }),
  )

  hide ||=
    !!shipperType && !propertySpecs.validShipperTypes.includes(shipperType)

  disabled ||= isLabelEnableMode && !isLabelPropertyEnabled

  if (hide) {
    return null
  }

  if (isSummary) {
    return label
  }

  if (isPickMode && !isLabelPropertyEnabled) {
    return (
      <PickLabelProperty
        label={label}
        labelProperty={labelProperty}
        checkedSelector={labelPropertyCheckedSelector}
      />
    )
  }

  return (
    <li
      className={cn`list__item--shipping-options margin-bottom-15 ${{
        error: errorMessage,
        'property-disabled': disabled,
      }} ${className}`}
    >
      <div className="wrap--edit-preset-form-input">
        <label
          className="inline-block margin-right-5 margin-bottom-0"
          htmlFor={id}
        >
          <span className="label--config__txt">
            {Label ? <Label /> : label}
          </span>
        </label>
        <button
          className="btn btn--link inline-block fs-n1 v-align-base"
          type="button"
          id={id}
          disabled={disabled}
          onClick={() => onClick(labelInfoID, shipperType)}
        >
          {children}
        </button>
        {errorMessage && (
          <small className="error error-message">{errorMessage}</small>
        )}
      </div>
      <EnableLabelProperty
        labelProperty={labelProperty}
        checkedSelector={labelPropertyCheckedSelector}
      />
    </li>
  )
}
